import { render, staticRenderFns } from "./concierge-buyers-form.vue?vue&type=template&id=6eaa2870&"
import script from "./concierge-buyers-form.vue?vue&type=script&lang=js&"
export * from "./concierge-buyers-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports